/**
 * HelpModal
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Modal } from 'react-bootstrap';

function HelpModal(props) {
  const { template, onHide } = props;
  const { helpHeader, options } = template;

  return (
    <Modal show onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title><FormattedMessage {...helpHeader} /></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {options.map((opt) => (
          <p key={opt.value} className="help-block">
            <b><FormattedMessage {...opt.label} /></b>
            &mdash;
            <FormattedMessage {...opt.help} />
          </p>
        ))}
      </Modal.Body>
    </Modal>
  );
}

HelpModal.propTypes = {
  onHide: PropTypes.func,
  template: PropTypes.object,
};

export default HelpModal;
